import { render, staticRenderFns } from "./PanelRegister.vue?vue&type=template&id=3762b323&"
import script from "./PanelRegister.vue?vue&type=script&lang=js&"
export * from "./PanelRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports